module.exports = "<div class=schedule-container> <div class=select-date> <span class=date-tips>设置起始时间：</span> <div class=\"start-date schedule-date-picker\"> </div> <span class=date-tips>设置结束时间：</span> <div class=\"end-date schedule-date-picker\"> </div> <span class=ok-btn>确定</span> </div> <div class=schedule-content> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.schedule/calendar.schedule.html
// module id = 4949
// module chunks = 50